import * as React from "react";
interface StepIndicatorProps {
  currentStep: number;
  answersByStep: number[];
  questionsPerStep: number[];
  labels: string[];
  stepSizes?: number[];
  allGreen?: boolean;
  onStepClick?: (stepIndex: number) => void;
}
export const StepIndicator: React.FC<StepIndicatorProps> = ({
  currentStep,
  answersByStep,
  questionsPerStep,
  labels,
  stepSizes = Array(labels.length).fill(1),
  onStepClick,
  allGreen,
}) => {
  const totalSteps = labels.length;
  return (
    <div className="flex items-center w-full mx-auto gap-2">
      {labels.map((label, idx) => {
        const fillFraction = Math.min(1, questionsPerStep[idx] ? answersByStep[idx] / questionsPerStep[idx] : 0);
        const stepWidth = (100 / totalSteps) * stepSizes[idx];
        return (
          <div
            key={idx}
            className={`${allGreen && "cursor-pointer"} "relative flex-grow`}
            style={{
              flexBasis: `${stepWidth}%`, // Make each step take up an equal fraction of available space
            }}
            onClick={() => onStepClick?.(idx)}
          >
            <div className="h-[10px] w-full mb-1 bg-gray-300 relative overflow-hidden">
              <div
                className={`absolute left-0 top-0 bottom-0 transition ${allGreen ? "bg-green-800" : idx <= currentStep ? "bg-green-800" : "bg-gray-300"}`}
                style={{ width: allGreen ? "100%" : `${Math.min(fillFraction, 1) * 100}%` }}
              />
            </div>
            <div className={`text-xs font-semibold text-gray-700`}>{label}</div>
          </div>
        );
      })}
    </div>
  );
};
